import React, { lazy } from 'react';
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import styles from "./PrayerRequestMain.module.scss";
import { usePrayerRequestPage } from '../../logic/usePrayerRequestpage';
import { useSeo } from '../../logic/useSeo';
import { TitleComponent } from '../TitleComponent'
import { Link } from "react-router-dom";

const Partners = lazy(() => import("../Partners"))
const PrayerBanner = lazy(() => import("../PrayerBanner"))
const PrayerDescription = lazy(() => import("../PrayerDescription"))
const TestimonialSlider = lazy(() => import("../TestimonialSlider"))
const PrayerBook = lazy(() => import("../PrayerBook"));
const PrayerRequestForm = lazy(() => import("../PrayerRequestForm"));

const PrayerRequestMain = () => {
    const requestPageData = usePrayerRequestPage();
    useSeo();
    return (
        <>
            <TitleComponent title=" Prayer Request" />
            <PrayerBanner bannerImage={requestPageData?.pagebanner}
                bannerImageMobile={requestPageData?.pagebannermobile}
                bannerTitle={requestPageData?.pageTitle} />
            <PrayerDescription title={requestPageData?.descriptionTitle} subtitle={requestPageData?.descriptionSubTitle} desc={requestPageData?.description} />
            <div className={styles.pryr_rqst_wrp}>
                <Container>
                    <Row >
                        <Col xs={12} lg={8}>
                            <PrayerRequestForm />
                        </Col>
                        <Col xs={12} lg={4} >
                            <TestimonialSlider />
                        </Col>
                    </Row>
                </Container>
            </div>
            <PrayerBook data={requestPageData} />
        </>
    )
}

export default PrayerRequestMain;